/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React,{useState, useEffect, useContext} from 'react'
import './style.css'
import { Uploadconfig } from '../../redux/helper/upload-config';
import ThreeDotsLoader from '../LoadingDots';
import Spinner from '../Spinner';
// const Buffer =  Array;
// window.Buffer = window.Buffer || require('buffer').Buffer;
import { distributorService } from '../../service/distributor.service';
import HeaderContext from '../Context/HeaderContext';
import { DistributorActions } from '../../redux/actions';
import { uploadFileToS3 } from '../../redux/helper/s3Upload';
import { creatUUId } from '../../redux/helper/CreateUUID';

export default function RaiseTicket() {
    const {
        SetSuccessMessage,
        setcolorValue,
        SetErrorMessage,
        setisPopup,
        setraiseTicket,
        raiseTicket
    } = useContext(HeaderContext);
    const [TicketInfo, setTicketInfo] = useState({
        subject:'',
        category:'',
        comment:'',
        file:[]
    })
    const [spinner, setspinner] = useState(false)
    const [categoryList, setCategoryList] = useState([])
    // const ReactS3Client = new S3(Uploadconfig);
    const [loading, setloading] = useState(false)

    const [showDropdown, setshowDropdown] = useState(false)
    const handleUploadedFiles = (val,key)=>{
        const data={...TicketInfo};
        const idx = data[key].indexOf(val)
        if(idx>-1){
            data[key].splice(idx,1)
        }else{
            data[key].push(val)
        }
        setspinner(false)
        setTicketInfo(data)

    }
    const handleChange=(e)=>{
        const {id,value}=e.target
        setTicketInfo((prevState)=>({
            ...prevState,
            [id]:value
        }))
    }


    const handleUploadDoc = async (e, key) => {
        const files = e.target.files;
        setspinner(true);
    
        if (!files || files.length === 0) {
            setspinner(false);
            return;
        }
        try {
            let nameKey = `eub/${creatUUId()}/${files[0].name}`
            const fileUrl = await distributorService.uploadImages(nameKey, files[0])
            const keyPath = fileUrl.split('.com/')[1]; // get the path for storing in backend
            await distributorService.getSignedUrl(keyPath,'get')
            handleUploadedFiles(keyPath, key);
        } catch (err) {
            console.error("S3 Upload Error:", err);
            handleErrorMessage("File upload failed");
        } finally {
            setspinner(false);
        }
    };

    const dropdownKey=[{
        id:1,
        key:'Quality Complaint'
    },
    {
        id:2,
        key:'Transportation Issue'
    },{
        id:3,
        key:'TC Required'
    },{
        id:4,
        key:'Insurance Matter'
    },{
        id:5,
        key:'A/c Related Query'
    },{
        id:6,
        key:'No Response from Sales Team'
    },{
        id:7,
        key:'Delivery Query'
    },{
        id:8,
        key:'Material Availability'
    },{
        id:9,
        key:'Billing Status'
    },{
        id:10,
        key:'CN/DN Status'
    },{
        id:11,
        key:'Product Information'
    }]
    const [submitSelected, setsubmitSelected] = useState(false);
    const handleErrorMessage = (message)=>{
        SetErrorMessage(message ||'Something went wrong');
        setcolorValue(true);
        setTimeout(() => {
            SetErrorMessage('');
            setcolorValue(false);
            setloading(false)

        }, 1000);
    }
    const handleSuccessMessage = (message)=>{
        SetSuccessMessage(message);
        setraiseTicket(false)
        setTimeout(() => {
            SetSuccessMessage('');
            setcolorValue(false);
            setloading(false)
        },1000)
    }
    let handlecheck=()=>{
        let valid=true
        TicketInfo['subject'] = TicketInfo['subject'].trim()
        TicketInfo['comment'] = TicketInfo['comment'].trim()
        Object.keys(TicketInfo).map((key)=>{
            
            if(valid===true){
                switch(key){
                case 'subject':
                case 'category':
                case 'comment':
                    console.log( TicketInfo[key])
                    if(TicketInfo[key]==='' ){
                        valid=false
                    }
    
                }
            }
        })
        return valid
    }
    const checkLength =(e)=>{
        return e.target.value?.split(' ').length <=500
    }
    const handleSubmit=async()=>{
        setloading(true)
        if(!handlecheck()){
            setsubmitSelected(true);
            setloading(false)

            return;
        }

        const body = {
            "record_type": "TICKETS",
            "subject": TicketInfo.subject,
            "category": TicketInfo.category,
            "comment": TicketInfo.comment,
            "attachments": TicketInfo.file,
        }
        const ticket = await distributorService.RaiseATicket(body);
        if(!ticket.error && ticket.data.success_status){
            handleSuccessMessage(ticket.data.message)
        }else{
            handleErrorMessage(ticket?.message?.response?.data?.message)
        }
    }
    function handlePaste(e) {
        var clipboardData, pastedData;
      
        // Stop data actually being pasted into div
        e.stopPropagation();
      
        // Get pasted data via clipboard API
        clipboardData = e.clipboardData || window.clipboardData;
        pastedData = clipboardData.getData('Text');
        // Do whatever with pasteddata
        debugger
        if(e.target.value.split(' ').length + pastedData.split(' ').length <=501 ){
            handleChange(e)
        }else{
            e.preventDefault();
            handleErrorMessage('Words should be less than or equal to 500')

        }
    }
    const handleFetch= async()=>{
        const categories = await distributorService.ZendeskCategoryList()
        console.log(categories.data.data)
        setCategoryList(categories.data.data)
    }

    useEffect(() => {
        handleFetch()
    },[])
    const imgType=['png','jpg','jpeg','svg']
    return (
        <div className={`modal fade fixed top-0 left-0  ${raiseTicket ? 'show' : 'hidden'} w-full h-full outline-none overflow-x-hidden overflow-y-auto`} id="Raiseticket" tabIndex="-1" aria-labelledby="Raiseticket" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered relative lg:max-w-[443px] lg:min-w-[443px] w-full px-3 mx-auto pointer-events-none" style={{ margin: 'auto'}}>
                <div className="modal-content border-none shadow-lg relative flex flex-col pointer-events-auto w-full bg-white border border-[#707070] bg-clip-padding rounded-md outline-none text-current md:px-[30px] sm:px-4 px-3 sm:pt-[32px] pt-4 pb-5">
                    <div className="modal-header flex flex-shrink-0 items-center justify-center rounded-t-md relative">
                        <h5 className="sm:text-xl text-lg font-semibold leading-normal text-[#090406]" id="exampleModalScrollableLabel">
                            Raise a Ticket
                        </h5>
                        <button
                            onClick={()=>setraiseTicket(false)}
                            type="button" className="absolute top-0 right-0" data-bs-dismiss="modal" aria-label="Close">
                            <img src="/images/Icon-ionic-ios-close.svg" alt="" />
                        </button>
                    </div>
                    <div className="modal-body pt-[22px]">
                        <div>
                            <label htmlFor="Subject" className="text-base text-[#555259] font-semibold">Subject<span className="text-[#555259] pl-1">*</span></label>
                            <input 
                                onChange={(e)=>handleChange(e)}
                                onFocus={()=>setsubmitSelected(false)}
                                type="text" id="subject" className={`w-full sm:mt-3 mt-1 h-12 pl-3 rounded-lg outline-0 border ${submitSelected&&TicketInfo.subject===''?'border-[red]':'border-[#707070]'} sm:placeholder:text-base placeholder:text-sm placeholder:text-[#808285] placeholder:font-normal`} placeholder="Enter the Subject" />
                            {submitSelected&&TicketInfo.subject==='' &&<span className='text-[red] font-normal' style={{fontSize:'14px'}}>Subject field is mandatory</span>}
                        </div>
                        <p className="mt-4 text-[#555259] font-semibold text-base">Category
                            <span className=" text-[#555259] pl-1">*</span></p>
                        <div className="dropdown relative">
                            <button
                                onClick={()=>{
                                    setshowDropdown(!showDropdown)
                                    setsubmitSelected(false)
                                }} className={`dropdown-toggle sm:mt-3 mt-1 w-full h-12 pl-3 rounded-lg sm:text-base text-sm text-[#808285] font-normal border ${submitSelected&&TicketInfo.category===''?'border-[red]':'border-[#707070]'} text-left`} type="button"id="dropdownMenuButton1"data-bs-toggle="dropdown" aria-expanded="false">
                                {TicketInfo.category===''?'Select a Category':TicketInfo.category}
                            </button>
                            {submitSelected&&TicketInfo.category==='' &&<span className='text-[red] font-normal' style={{fontSize:'14px'}}>Category field is mandatory</span>}

                            <img src="/images/chevron-down-category.svg" alt="icon" className=" absolute sm:top-8 top-6 right-5" />
                            <ul className={`dropdown-menu overflow-auto h-28 shadow-s10 p-3 absolute${!showDropdown?' hidden':' show'}  w-full bg-[#FFFFFF]`} aria-labelledby="dropdownMenuButton1">
                                {categoryList.map((val,i)=>(
                                    <li key={val.LOOKUP_CODE}
                                        className={`dropdown-item font-normal text-base text-[#090406] cursor-pointer ${i !==0 ?'mt-1.5':''}`} onClick={()=>{
                                            setTicketInfo((prevState)=>({
                                                ...prevState,
                                                'category':val.DESCRIPTION
                                            }))
                                            setshowDropdown(false)
                                        }}>{val.DESCRIPTION}</li>

                                ))}
                            
                            </ul>
                        </div>
                        <div className="relative sm:mt-5 mt-4">
                            <label htmlFor="inp" className="text-base font-semibold text-[#555259]  upload">Comment<span className="text-[#555259] pl-1">*</span></label>
                            <textarea 
                                onFocus={()=>setsubmitSelected(false)}
                                onPaste={(e)=>handlePaste(e)}
                                onChange={(e)=>{
                                    if(checkLength(e)){
                                        handleChange(e)
                                    }
                                }} name="enterMoremessage" 
                                value={TicketInfo.comment}id="comment" className={`input-feild w-full h-[108px] resize-none px-[13px] py-[14px] border ${submitSelected&&TicketInfo.comment===''?'border-[red]':'border-[#707070]'} rounded-lg sm:mt-3 mt-1 sm:text-base text-sm font-normal text-[#000000] sm:placeholder:text-base placeholder:text-sm placeholder:text-[#808285] placeholder:font-normal outline-none custom-scrollbar`} placeholder="Enter specific comment"></textarea>
                            <p className="absolute bottom-[10px] right-5 px-1 bg-[#FFFFFF] text-xs13 font-normal text-[#808285] words">500 words</p>
                        </div>
                        {submitSelected&&TicketInfo.comment==='' && TicketInfo.comment.trim().length <= 0 &&<span className='text-[red] font-normal' style={{fontSize:'14px'}}>Comment field is mandatory</span>}

                  
                        {/* <!-- showing uploaded file --> */}
                        <div className="file-uploaded flex flex-wrap">
                            {TicketInfo.file.length>0 && TicketInfo.file.map((item,i)=>(
                                <div className="mt-3.5 flex items-center file-uploaded cursor-pointer" key={item}>
                                    <span className='flex items-center'>
                                        <img src={`/images/${!imgType.includes(item.split('.').at(-1))?'doc.svg':'img-thumb.png'}`} alt="uploaded-img" className='mr-1' style={{width:'12px',height:'12px'}}/>{item.split('/').at(-1)}</span>
                                    <span className="ml-2.5">
                                        <img src="/images/circle-close.svg" alt="close-icon" className="cursor-pointer" onClick={()=>{
                                            handleUploadedFiles(item,'file')
                                        }}/>
                                    </span>
                                </div>
                            ))}
                        </div>
                    
                        {/* <p class="sm:text-base text-xs6 font-semibold text-[#555259] mt-2.5 upload">Additional Details</p> --> */}
                        <div className="relative mt-2.5 mb-1">
                            <input type="file" className="opacity-0 absolute top-0 left-0 cursor-pointer w-20 h-5" onChange={(e)=>handleUploadDoc(e,'file')} />
                            <span className='flex'><label htmlFor="file" className="text-sm font-semibold text-[#808285] cursor-pointer" style={{cursor:'pointer'}}>+ Attach file</label>
                                {spinner && <Spinner />}</span>
                        </div>
                        <div className="flex justify-center">
                            <button
                                onClick={()=>handleSubmit()}
                                type="button" className="w-full mt-10 sm:w-[306px] sm:py-3.5 py-2 rounded-lg bg-[#555259] sm:text-lg text-base font-semibold text-[#FFFFFF] raise-ticket flex items-center justify-center" data-bs-dismiss="modal" aria-label="Close" data-bs-toggle="modal" data-bs-target="#orderPlaced">
                                {loading?<ThreeDotsLoader/>:'Raise Ticket'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
